import {
  GET_EMPLOYEE_CATEGORY_TAGS,
  FETCH_EMPLOYEE_CATEGORY_TAG,
  ADD_EMPLOYEE_CATEGORY_TAG,
  UPDATE_EMPLOYEE_CATEGORY_TAG,
  DELETE_EMPLOYEE_CATEGORY_TAG,
  CLEAR_EMPLOYEE_CATEGORY_TAGS,
  EMPLOYEE_CATEGORY_TAGS_PAGE,
  CLEAR_ALL,
  EMPLOYEE_CATEGORY_TAGS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  employee_category_tags: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function employeeCategoryTags(state = initialState, action) {
  switch (action.type) {
    case EMPLOYEE_CATEGORY_TAGS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_EMPLOYEE_CATEGORY_TAGS:
      return {
        ...state,
        employee_category_tags: action.payload,
        pending: false,
      };
    case EMPLOYEE_CATEGORY_TAGS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_EMPLOYEE_CATEGORY_TAG:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_EMPLOYEE_CATEGORY_TAG:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_EMPLOYEE_CATEGORY_TAG:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_EMPLOYEE_CATEGORY_TAG:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_EMPLOYEE_CATEGORY_TAGS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}